import { Navigate, Outlet } from "react-router-dom";
import { checkUserType } from "../../utils/helper";

function FindSpecialistProtected() {
  const userType = checkUserType();
  const role = userType === false ? "guest" : userType;
  

  if (role === "guest" || role === "member") {
    return <Outlet />;
  }

  // block specialist / admin
  return <Navigate to="/specialist/profile" replace />;
}

export default FindSpecialistProtected;
